import { render } from "./ReleaseModal.vue?vue&type=template&id=0d903702"
import script from "./ReleaseModal.vue?vue&type=script&lang=js"
export * from "./ReleaseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__